import { render } from "./uiToggleTheme.vue?vue&type=template&id=a9e4ab2c&scoped=true&ts=true"
import script from "./uiToggleTheme.vue?vue&type=script&lang=ts"
export * from "./uiToggleTheme.vue?vue&type=script&lang=ts"

import "./uiToggleTheme.vue?vue&type=style&index=0&id=a9e4ab2c&lang=css&scoped=true"

import exportComponent from "C:\\AttiTec\\DogToDo\\dev\\todo-list-vuejs-pwa-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9e4ab2c"]])

export default __exports__